import {
  GET_COMPANY_LEVEL_LOAN_DETAILS_FAILURE,
  GET_COMPANY_LEVEL_LOAN_DETAILS_LOADING,
  GET_COMPANY_LEVEL_LOAN_DETAILS_SUCCESS,
} from "../../actions/types";

const INITIAL_STATE = {
  companyLoans: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const getCompanyLoansReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COMPANY_LEVEL_LOAN_DETAILS_LOADING:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: true,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_COMPANY_LEVEL_LOAN_DETAILS_SUCCESS:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: false,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_COMPANY_LEVEL_LOAN_DETAILS_FAILURE:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: false,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    default:
      return INITIAL_STATE;
  }
};

export default getCompanyLoansReducer;
